import { ThreadModel, ThreadStateEnum } from '@anecdotes/commenting';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  HostBinding,
  Input,
  OnInit, inject, DestroyRef } from '@angular/core';
import { Observable } from 'rxjs';
import { ThreadViewModel } from '../../models';

import { filter } from 'rxjs/operators';
import { CommentingFacadeService } from '../../services';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-thread-item',
  templateUrl: './thread-item.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ThreadItemComponent implements OnInit {
  private readonly destroyRef = inject(DestroyRef);
  @HostBinding('class')
  private classes = 'block rounded-md border border-solid border-navy-40 overflow-hidden bg-white shadow-sm';

  @Input()
  resource: ThreadViewModel;

  thread$: Observable<ThreadModel>;

  get isThreadCreation(): boolean {
    return this.resource.isCreation;
  }

  isActiveThread: boolean;

  isResolvedThread: boolean;

  constructor(private commentingFacadeService: CommentingFacadeService, private cd: ChangeDetectorRef) {}

  ngOnInit(): void {
    if (!this.resource.isCreation) {
      this.commentingFacadeService
        .getThreadById(this.resource.threadId)
        .pipe(
          filter(Boolean),
          takeUntilDestroyed(this.destroyRef)
        )
        .subscribe((thread) => {
          this.isActiveThread = thread.state === ThreadStateEnum.Active;
          this.isResolvedThread = thread.state === ThreadStateEnum.Resolved;
          this.cd.detectChanges();
        });
    }
  }
}
